export const getDevHeaders = () => {
  if (!DEV_X_PRODUCT_IDENTIFIER && !DEV_X_PRODUCT_DOMAIN) return;
  return {
    'dev-x-product-identifier': DEV_X_PRODUCT_IDENTIFIER,
    'dev-x-product-domain': DEV_X_PRODUCT_DOMAIN
  };
};
